import { CalendarIcon, Flex, HeroIconProps, Text, TextProps, type FlexProps } from 'components'
import { formatDates } from 'utils'

export interface Props extends Omit<FlexProps, 'children'> {
  endTime?: any
  iconProps?: HeroIconProps
  placeholder?: string
  startTime: any
  textProps?: TextProps
  /** (default: 'UTC') UTC, local or IANA timezone */
  timeZone?: string
}

export default function DatesDisplay({
  endTime,
  iconProps,
  placeholder = '--',
  startTime,
  textProps,
  timeZone = 'UTC',
  ...rest
}: Props) {
  return (
    <Flex align="center" gap={1} {...rest}>
      <CalendarIcon fontSize="sm" {...iconProps} />
      <Text textStyle="bodyXSmall" opacity={0.7} truncate textOverflow="ellipsis" {...textProps}>
        {formatDates(startTime, endTime, timeZone) || placeholder}
      </Text>
    </Flex>
  )
}
